export const createCalendarEvent = () => {
    const eventTitle = 'Shashtipoorthi - 60th Birthday Celebration';
    const eventLocation = 'Schulhaus Feldheim 3, 6312 Steinhausen';
    const eventDescription = 'Celebration of Shashtipoorthi - A Significant Milestone of 60 Years';

    const startDate = '20251026T090000';
    const endDate = '20251026T120000';

    const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(eventTitle)}&dates=${startDate}/${endDate}&details=${encodeURIComponent(eventDescription)}&location=${encodeURIComponent(eventLocation)}&sf=true&output=xml`;

    return googleCalendarUrl;
};

export const downloadICSFile = () => {
    const eventTitle = 'Shashtipoorthi - 60th Birthday Celebration';
    const eventLocation = 'Schulhaus Feldheim 3, 6312 Steinhausen';
    const eventDescription = 'Celebration of Shashtipoorthi - A Significant Milestone of 60 Years';

    const startDate = '20251026T090000';
    const endDate = '20251026T120000';

    const icsContent = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Shashtipoorthi//RSVP//EN',
        'BEGIN:VEVENT',
        `DTSTART:${startDate}`,
        `DTEND:${endDate}`,
        `SUMMARY:${eventTitle}`,
        `DESCRIPTION:${eventDescription}`,
        `LOCATION:${eventLocation}`,
        'STATUS:CONFIRMED',
        'BEGIN:VALARM',
        'TRIGGER:-PT24H',
        'DESCRIPTION:Reminder: Shashtipoorthi celebration tomorrow',
        'ACTION:DISPLAY',
        'END:VALARM',
        'END:VEVENT',
        'END:VCALENDAR'
    ].join('\r\n');

    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'shashtipoorthi-celebration.ics';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};